import React from 'react'

type LinkProps = {
  href?: string
  className?: string
  label?: string | React.ReactNode
  target?: string
  variant?: 'primary' | 'secondary'
  title?: string
  style?: React.CSSProperties
  children?: React.ReactNode
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

export const Link = ({
  href,
  className = '',
  label,
  variant,
  style,
  target,
  title,
  onClick,
  children
}: LinkProps) => {
  const _className = `link link-wrap ${className}`
  const _style = {
    display: 'inline-block',
    cursor: 'pointer',
    ...style
  }

  return <div className={_className} style={_style}>
    <a title={title} href={href}
      target={target}
      className={variant ? `link-${variant}` : ''}
      onClick={onClick}>{label || children}</a>
  </div>
}